import containerFuild from '../html-snippets/container-fuild.js';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import css from '../css-snippets/fastvaluedeal-table';

const CHECK_ICON = 'https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbae77dd187b38abd302a.png';
const X_ICON = 'https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png';
const LOGO_IMAGE = 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a21360dc39d04ad507f4adf.png';

const iconCell = src => `<p style="text-align:center;"><img src="${src}" alt=""></p>`;

const defaultTableHtml = `
<figure class="table">
  <table class="ck-table-resized">
    <colgroup>
      <col style="width:28%;">
      <col style="width:24%;">
      <col style="width:24%;">
      <col style="width:24%;">
    </colgroup>
    <thead>
      <tr>
        <th style="vertical-align:middle;">
          <figure class="image"><img src="${LOGO_IMAGE}" alt=""></figure>
        </th>
        <th style="background-color:#000000;text-align:center;vertical-align:middle;">
          <h2 style="text-align:center;"><span style="color:hsl(0,0%,100%);"><strong>WAVEMAX</strong></span></h2>
        </th>
        <th style="text-align:center;vertical-align:middle;">
          <p style="text-align:center;"><span style="color:hsl(0,0%,0%);"><strong>Cable TV</strong></span></p>
        </th>
        <th style="text-align:center;vertical-align:middle;">
          <p style="text-align:center;"><span style="color:hsl(0,0%,0%);"><strong>Streaming <br> Subscription</strong></span></p>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>Portable</strong></td>
        <td style="background-color:#000000;text-align:center;vertical-align:middle;">${iconCell(CHECK_ICON)}</td>
        <td style="text-align:center;">${iconCell(X_ICON)}</td>
        <td style="text-align:center;">${iconCell(CHECK_ICON)}</td>
      </tr>
      <tr>
        <td><strong>Affordable</strong></td>
        <td style="background-color:#000000;text-align:center;vertical-align:middle;">${iconCell(CHECK_ICON)}</td>
        <td style="text-align:center;">${iconCell(X_ICON)}</td>
        <td style="text-align:center;">${iconCell(X_ICON)}</td>
      </tr>
      <tr>
        <td><strong>Simple to use</strong></td>
        <td style="background-color:#000000;text-align:center;vertical-align:middle;">${iconCell(CHECK_ICON)}</td>
        <td style="text-align:center;">${iconCell(CHECK_ICON)}</td>
        <td style="text-align:center;">${iconCell(CHECK_ICON)}</td>
      </tr>
      <tr>
        <td><strong>Wide channel selection</strong></td>
        <td style="background-color:#000000;text-align:center;vertical-align:middle;">${iconCell(CHECK_ICON)}</td>
        <td style="text-align:center;">${iconCell(X_ICON)}</td>
        <td style="text-align:center;">${iconCell(X_ICON)}</td>
      </tr>
      <tr>
        <td><strong>High-quality signal</strong></td>
        <td style="background-color:#000000;text-align:center;vertical-align:middle;">${iconCell(CHECK_ICON)}</td>
        <td style="text-align:center;">${iconCell(X_ICON)}</td>
        <td style="text-align:center;">${iconCell(X_ICON)}</td>
      </tr>
    </tbody>
  </table>
</figure>
`;

const dividerHtml = dividerPrimary({
  show: true,
  maxWidth: 80,
  height: 6,
  align: 'center',
  backgroundColor: '#5b04de',
});

const contentHtml = `
<div class="fvd-table-content container" data-attribute="fvd-table-content">
  <div class="fvd-table__header" data-attribute="fvd-table__header">
    <div class="fvd-table__title" data-attribute="fvd-table__title">
      <h2 style="text-align:center;"><strong>How it stands out among others</strong></h2>
    </div>
    <div class="fvd-table__divider" data-attribute="fvd-table__divider">
      ${dividerHtml}
    </div>
  </div>
  <div class="wrap-card">
    <div
      data-attribute="table-content"
      data-border-color="#ebeced"
      data-border-weight="1px"
      data-col-border="true"
      data-row-border="true"
      data-border-full="false"
      class="table-content"
    >
      ${defaultTableHtml}
    </div>
  </div>
</div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#FFFFFF',
  backgroundImage: '',
});
